// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionTitleWidget_root__riKrM","media":"SectionTitleWidget_media__-mjNG","title":"SectionTitleWidget_title__gU4UZ","subTitle":"SectionTitleWidget_subTitle__1RaAc"};